import './About.scss';
import Letters from '../Letters';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCss3,
  faHtml5,
  faJsSquare,
  faNodeJs,
  faPython,
  faReact,
} from '@fortawesome/free-brands-svg-icons';
import certificate from '../../assets/images/bootcamp.png';
import boyScout from '../../assets/images/boy_scout.jpeg';

const cubeFaces = [
  { className: 'sidePy', icon: faPython, color: '#6495ED', label: 'Python' },
  { className: 'sideHTML', icon: faHtml5, color: '#C46210', label: 'HTML5' },
  { className: 'sideCSS', icon: faCss3, color: '#1F75FE', label: 'CSS3' },
  { className: 'sideReact', icon: faReact, color: '#5ED4F4', label: 'React' },
  { className: 'sideJS', icon: faJsSquare, color: '#F0DB4F', label: 'JavaScript' },
  { className: 'sideNode', icon: faNodeJs, color: '#03C03C', label: 'Node.js' },
];

const credentials = [
  {
    image: certificate,
    alt: 'Full Stack Developer certificate from The University of Texas at Austin Coding Boot Camp',
    title: 'Full Stack Developer Certificate',
    detail: 'UT Austin Coding Boot Camp — May 2023',
  },
  {
    image: boyScout,
    alt: 'Matthew Walker in his Eagle Scout uniform',
    title: 'Eagle Scout',
    detail: 'Troop 511 — Austin, TX',
  },
];

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    // Clean up so the timer can't fire after the page has been navigated away
    // from — the old version leaked a setState on an unmounted component.
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container about-page">
      <header className="page-header">
        <h1>
          <Letters
            letterClass={letterClass}
            letterArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
            index={20}
          />
        </h1>
        <p className="lead">
          Economics graduate from The University of Texas at Austin, now
          pursuing an MS in Business Technology &amp; AI.
        </p>
      </header>

      <div className="about-grid">
        <div className="about-bio">
          <p>
            I graduated from UT Austin with a BA in Economics and am currently
            pursuing a Master of Science in Business Technology &amp; AI. I am
            also developing a few personal business projects that I will be
            adding to this portfolio soon.
          </p>

          <p>
            I earned my Full Stack Developer certificate through{' '}
            <a
              className="inline-link"
              target="_blank"
              rel="noreferrer"
              href="https://techbootcamps.utexas.edu/"
            >
              The University of Texas at Austin Coding Boot Camp
            </a>
            , where I worked with HTML, CSS, JavaScript, Python, NodeJS and
            React, along with MongoDB, MySQL and ExpressJS.
          </p>

          <p>
            I am an Eagle Scout from Troop 511 in Austin, TX, and a huge fan of
            the Dallas Cowboys and the Texas Longhorns. During my free time I
            enjoy playing video games and learning new coding languages.
          </p>
        </div>

        <aside className="about-stack">
          <h2 className="section-label">Tech I work with</h2>

          <div className="cube-stage">
            <div className="cube">
              {cubeFaces.map(({ className, icon, color, label }) => (
                <div className={`cube-face ${className}`} key={className}>
                  <FontAwesomeIcon icon={icon} color={color} title={label} />
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>

      <section className="credentials">
        <h2 className="section-label">Credentials</h2>

        <div className="credential-grid">
          {credentials.map(({ image, alt, title, detail }) => (
            <figure className="credential-card" key={title}>
              <div className="credential-media">
                <img src={image} alt={alt} loading="lazy" />
              </div>
              <figcaption>
                <span className="credential-title">{title}</span>
                <span className="credential-detail">{detail}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
